import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { constants } from 'src/app/shared/common/contants';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { VaultObjectRelationshipService } from 'src/app/shared/services/vault-object-relationship.service';
import { VaultObjectRelationshipPopupComponent } from './vault-object-relationship-popup/vault-object-relationship-popup.component';
import * as moment from 'moment';
import {UserRoutingModule} from 'src/app/user/user-routing/user-routing.module';
import { ReportlinksserviceService } from 'src/app/user/reportlinks/reportlinksservice.service';
import { UploadExcelFileComponent } from '../upload-excel-file/upload-excel-file.component';
import { ImportJsonComponent } from 'src/app/shared/common/ImportJsonComponent ';

@Component({
    selector: 'app-vault-object-relationship',
    templateUrl: './vault-object-relationship.component.html',
    styleUrls: ['./vault-object-relationship.component.scss'],
    standalone: false
})
export class VaultObjectRelationshipComponent implements OnInit {

  backgroundColorScreen=""
  backgroundColorButton=""
  columnDefs
  defaultColDef
  rowSelection
  paginationNumberFormatter
  paginationPageSize
  gridApi
  grid
  components
  getSelectedRows
  pageSize=20;
  currentPage;
  pageNo;
  totalPages;
  lastPage;
  nextPage;
  nextPagePlusOne;
  rowData;
  isdisable=false;
  value;
  rowClassRules;
  dnsName;
  buttonIdList: any = [];
  tableName: string;
  vaultids: any;
  columnsOfAction: boolean;
  dataFiltered: any;
  gridAPI: any;
  defaultId: number;
  dnsnames: any[];
  name: any;
  defaultLoginDns: any;
  isEnabled:false
  lastpage: any;
  // currentpage: any;
  nextpage: any;
  nextpageplusone: any;
  // totalpages: any;
  pagesize: any;
  importExportTableName = "vaultobjectrelationship";

  constructor(
    private localStorageSettings: LocalStorageSettingsService,
    private spinner: NgxUiLoaderService,
    private snackBar: MatSnackBar,
    private loginService: LoginService,
    private constants: constants,
    private service: CommonService,
    private dialog: MatDialog,
    private vaultObjectRelationshipService:VaultObjectRelationshipService,
    private userRoutingModule: UserRoutingModule,
    private reportLinkService:ReportlinksserviceService,
    private commonService: CommonService,
    private snackbar: MatSnackBar
  ) { }

  ngOnInit(): void {
    /* @added by Chandra R
        @date 01-01-2025
        @@desc Below code enable and disable the buttons  in UI based on permission
    */
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });
     const workspaceId = this.localStorageSettings.getSettings("WorkspaceId")
     this.commonService.retrieveDnsInfo(workspaceId).subscribe((response) => {
       
       console.log(response);
       
       if (response.error == true) {
         this.spinner.stop();
         this.snackBar.open(response.statusMessage, 'OK', { duration: 5000 });
         return null;
       } else {
         this.spinner.stop();
         const dnsInfoList = response;

 // Iterate and extract specific fields if needed
 dnsInfoList.forEach((item) => {
   console.log("Environment Name:", item.envname);
   console.log("DNS Name:", item.dnsname);
   console.log("Session ID:", item.sessionid);
   console.log("Tenant ID:", item.tenantid);
   // Access other fields as needed
 });

 // Or store it in a variable to use in HTML
   // const dnsDataArray = dnsInfoList;
   const dnsDataArray = response.map(item => ({
     id: item.vaultId,                         // backend vaultId → id
     name: item.envname,                       // envname → name
     source: item.dnsname,                     // dnsname → source (or sourceDnsId?)
     sourceDnsId: item.vaultconfigmstrid,     // vaultconfigmstrid → sourceDnsId
     target: item.dnsname,                     // dnsname again? Or from another field?
     targetDnsId: item.tenantid,               // tenantid → targetDnsId
     url: `https://${item.envname}/api`        // construct URL from envname or another field
   }));
   console.log(dnsDataArray)
   this.vaultids = dnsDataArray
   console.log(this.vaultids)
   this.dnsDropDown()
   this.selectDns(this.name)
       }
     });
   

    this.columnDefs=[
      {
        headerName: "Action",
        filter: false,
        cellRenderer: "buttonRenderer",
        cellRendererParams: {
          values:this.buttonIdList,
          edit: this.editIcon.bind(this),
          delete: this.deleteIcon.bind(this)
        },
        pinned: 'left',
        lockPinned: true,
        width: 170
      },
      {
        headerName: 'Id',
        headerTooltip: 'Id',
        tooltipValueGetter: (params) => 'Id : ' + params.value,
        field: 'id',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Object Name',
        headerTooltip: 'Object Name',
        tooltipValueGetter: (params) => 'Object Name : ' + params.value,
        field: 'objectName',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Parent Object Name',
        headerTooltip: 'Parent Object Name',
        tooltipValueGetter: (params) => 'Parent Object Name : ' + params.value,
        field: 'parentObjectName',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Unique Key Column',
        headerTooltip: 'Unique Key Column',
        tooltipValueGetter: (params) => 'Unique Key Column : ' + params.value,
        field: 'uniqueKeyColumn',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Columns From Parent File',
        headerTooltip: 'Columns From Parent File',
        tooltipValueGetter: (params) => 'Columns From Parent File : ' + params.value,
        field: 'columnsFromParentFile',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Parent Ref Column',
        headerTooltip: 'Parent Ref Column',
        tooltipValueGetter: (params) => 'Parent Ref Column : ' + params.value,
        field: 'parentRefColumn',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'DNS Id',
        headerTooltip: 'DNS Id',
        tooltipValueGetter: (params) => 'DNS Id : ' + params.value,
        field: 'dnsId',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Parent File Name',
        headerTooltip: 'Parent File Name',
        tooltipValueGetter: (params) => 'Parent File Name : ' + params.value,
        field: 'parentFileName',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Child File Name',
        headerTooltip: 'Child File Name',
        tooltipValueGetter: (params) => 'Child File Name : ' + params.value,
        field: 'childFileName',
        filter: 'agTextColumnFilter',
        width: 180
      },
      // {
      //   headerName: 'Migration Id',
      //   headerTooltip: 'Migration Id',
      //   tooltipValueGetter: (params) => 'Migration Id : ' + params.value,
      //   field: 'migrationid',
      //   filter: 'agTextColumnFilter',
      //   width: 180
      // },
      {
        headerName: 'Unique Key Column D2D Validation',
        headerTooltip: 'Unique Key Column D2D Validation',
        tooltipValueGetter: (params) => 'Unique Key Column D2D Validation : ' + params.value,
        field: 'uniquekeycolumnd2dvalidation',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Reference Column Mapping',
        headerTooltip: 'Reference Column Mapping',
        tooltipValueGetter: (params) => 'Reference Column Mapping : ' + params.value,
        field: 'refcolmapping',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
  headerName: 'Status',
  headerTooltip: 'Status',
  field: 'status',
  width: 120,
  cellStyle: (params) => {
    if (params.value === 'Yes') {
      return { color: 'green', 'text-align': 'center' };
    } else if (params.value === 'No') {
      return { color: 'red', 'text-align': 'center' };
    }
    return null;
  }
},


      {
        headerName: 'Primary Column',
        headerTooltip: 'Primary Column',
        tooltipValueGetter: (params) => 'Primary Column : ' + params.value,
        field: 'primarycolumn',
        filter: 'agTextColumnFilter',
        width: 180
      }
    ]
    this.rowClassRules = {
  sick: function (params) {
    return params.node.data.status === "No";
  },
};

    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true,
    };
    this.components = {
      buttonRenderer: Actionbutton
    }
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    // this.getVaultObjectRelationshipList()
    this.dnsName=this.localStorageSettings.getSettings("dnsName");
  }
  deleteIcon(e){
    console.log(e.rowData);
     if (e.rowData.status === 'No') {
    this.snackBar.open("This record is already deleted.", "OK", { duration: 3000 });
    return;
  }
    if (confirm(this.constants.confirmDeletion)) {
    this.spinner.start();
    this.vaultObjectRelationshipService.deleteVaultObjectRelationshipData(e.rowData.id).subscribe(res=>{
      if(res.error){
        this.spinner.stop();
        this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
      }else{
        this.spinner.stop();
        this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
        // this.getVaultObjectRelationshipList()
        this.selectDns(this.name)
      } 
    })
  }
  }
  editIcon(e) {
    console.log(e);
    let dialogRef = this.dialog.open(VaultObjectRelationshipPopupComponent, {
      maxWidth: '100vw',
      height: "90%",
      width: "55%",
      data: { "rowData": e.rowData,dnsId:this.dnsid},
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if(result){
        // this.getVaultObjectRelationshipList()
        this.selectDns(this.name)
      }
    });
  }
  openSaveForm(type){
    console.log(type);
    console.log(this.dnsid)
    let dialogRef = this.dialog.open(VaultObjectRelationshipPopupComponent, {
      maxWidth: '100vw',
      height: "90%",
      width: "55%",
      disableClose: true,
      data:{dnsId:this.dnsid}
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if(result){
        // this.onBtFirst()
        this.selectDns(this.name)
      }
    });

  }
  onBtExport() {
    this.gridApi.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi) {
      this.lastpage = this.gridApi.paginationIsLastPageFound();
      this.currentPage = this.gridApi.paginationGetCurrentPage() + 1
      this.nextpage = this.gridApi.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.gridApi.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalPages = this.gridApi.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {

    this.gridApi.paginationGoToPage(searchValue - 1);
  }

  onPageSizeChanged(newPageSize: number) {
    this.pageSize = newPageSize;
    this.gridApi.setGridOption('paginationPageSize', newPageSize);
  
    // Recalculate pagination info
    this.onPaginationChanged();
  }
  

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridApi.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridApi.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.gridApi.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.gridApi.paginationGoToLastPage();
  }
  onGridReady(params){
    console.log(params)
    console.log("service")
    let res: any
    this.grid = params;
    this.gridApi = params.api;
    this.selectDns(this.name)
    // this.pageNo=0
  //  this.vaultObjectRelationshipService.retreiveVaultObjectRelationshipData(this.pageNo,this.pageSize).subscribe(res=>{
  //   if(res.error){
  //     // this.spinner.stop();
  //     this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
  //   }else{
  //     this.rowData= res["content"];
  //     // this.gridApi.setGridOption('rowData', this.rowData)
  //     console.log(this.rowData);
  //     // this.currentPage=this.pageNo+1;
  //     // this.totalPages=res["totalPages"];
  //     // this.spinner.stop();
     
  //   }
  //  })
  }

  getVaultObjectRelationshipList(){
    this.spinner.start()
  //  this.pageNo=0
   this.vaultObjectRelationshipService.retreiveVaultObjectRelationshipData(this.pageNo,this.pageSize).subscribe(res=>{
    if(res.error){
      this.spinner.stop();
      this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
    }else{
      this.rowData= res["content"];
      console.log(this.rowData);
      this.gridApi.setGridOption('rowData', this.rowData);
      this.totalPages=res["totalPages"];
      this.spinner.stop();
    }
   })
  }
  downloadListFile(){
    this.spinner.start()
     this.vaultObjectRelationshipService.downloadVaultObjectRelationshipData().subscribe(res=>{
      if(res.error){
        this.spinner.stop();
        this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
      }else{
        console.log(res);
        
        let data= res;
        console.log(data);
        const currentDate = moment().format("DD_MM_YYYY");
        this.service.downloadFile(data,"VaultObjectRelationship_"+currentDate)
        this.spinner.stop();
      }
     })
  }
  /**
	 * @Author: Venkata Shyam
	 * @Date:19-05-2025
	 * @apiNote : This method will support upload csv file functionality where it will insert/update the data into table based on tableName
	 */
  onFileChange(event:any):void{
    const input = event.target as HTMLInputElement
    if(!input.files ||input.files.length===0){
      console.log("No file selected")
      this.snackBar.open("No file selected","OK",{ duration:5000 });
    }
    const file = input.files[0]
    const fileName =file.name
    const isCsvfile = fileName.endsWith('.csv')
    if (!isCsvfile) {
      alert('Only CSV files are allowed.');
      input.value = ''
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    console.log("CSV file ready to be sent:", fileName);
    const tablename= 'vaultobjectrelationship'
    this.spinner.start();
    this.snackBar.open("Uploading file. Please wait...", "OK", { duration: 3000 });
    this.vaultObjectRelationshipService.uploadFileForVaultObjectRelationship(tablename,this.dnsid,formData).subscribe(res=>{
      if(res.error){
        this.spinner.stop();
        this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
        input.value = ''
      }else{
        console.log(res);
        this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
        this.spinner.stop();
        input.value = ''
        this.selectDns(this.name)
      }
     })
  }

   /**
	 * @Author: Venkata Shyam
	 * @Date:10-06-2025
	 * @apiNote : this method is implemented to segregate the data based on source and target dns selection 
   * and it is specific to workspace that user login
	 */
  dnsid:number
  async selectDns(tempdnschange) {        
   // this.retrieve();
   // this. onGridReady(this.temprunHistory);
     if (this.tableName !== "objectmetadata") {
       for(let i=0;i<this.vaultids.length;i++){
         if(this.vaultids[i].name === tempdnschange){
           tempdnschange=this.vaultids[i].target
         }
       }
     }
     console.log(this.vaultids)
     let dnschange = {
       "dnschange": tempdnschange,
       "username": this.localStorageSettings.getSettings("AuthUsername")
     };
     console.log(dnschange);
     this.spinner.start();
     console.log("Selected DNS:", dnschange);
     let matchedSourceId = null;

     for (let i = 0; i < this.vaultids.length; i++) {
       if (this.vaultids[i].source === tempdnschange) {
         matchedSourceId = this.vaultids[i].sourceDnsId;
         break; // exit loop once found
       }
     }
     if(tempdnschange.startsWith("Source_") || tempdnschange.includes("Source_")){
       console.log("It is source")
       this.columnsOfAction = true
     }else{
       console.log("It is target")
       this.columnsOfAction = false
     }
     
     console.log("Matched sourceDnsId:", matchedSourceId);
     const cleanedDnsName = tempdnschange.replace(/^Source_/, '').replace(/^Target_/, '');
     console.log("Cleaned DNS Name:", cleanedDnsName);
     
     
   
     // First API call - Get Tenant ID based on DNS Name
     try {
       console.log("Calling API for getTenantidBasedOnName...");
       const dnsvalue = await this.service.getTenantidBasedOnName(cleanedDnsName).toPromise();
       // this.dnsid = Number(dnsvalue)
       this.dnsid = matchedSourceId
       console.log("DNS ID:", this.dnsid);
      
       let tableData = await this.service.getDataByDns(this.dnsid).toPromise();
       console.log("Filtered Data:", tableData);
       // this.dynamicData = tableData;
       const modifiedData = tableData.map(row => ({
         ...row,
         isSelected: false
       }));
           
        this.dataFiltered = modifiedData.filter(item => {
        return !(item.source && item.source.trim().toLowerCase() === "stage");
       });
       console.log(this.dataFiltered)
       this.gridApi.setGridOption('rowData', this.dataFiltered );
       // this.gridAPI.setGridOption('rowData', modifiedData);
     } catch (error) {
       console.error("Error occurred:", error);
       this.spinner.stop();
       alert('An error occurred while fetching the data.');
     } finally {
       this.spinner.stop(); // Ensure spinner stops in both success and error cases
     }
   
    
    }
    
    
     dnsDropDown(){
     //  console.log(userid);
        console.log(localStorage.getItem("vaultIds"))
        console.log(localStorage.getItem("defaultVaultId"))
        this.defaultId=+localStorage.getItem("defaultVaultId");
       //  this.vaultids =JSON.parse(localStorage.getItem("vaultIds"));
        console.log(this.vaultids)
        /*
         Modified By-Abhishek T
         Date-06-12-2023
         Desc-doing empty the dnsnames array to avoid the dns records duplication
        */
         this.dnsnames=[];
        for(let i=0;i<this.vaultids.length;i++){
          if(true){
            this.name = this.vaultids[i].target
            this.defaultLoginDns=this.vaultids[i]
            console.log(this.name)
            this.localStorageSettings.saveSettings("SelectedDnsName",this.vaultids[i].name);
            if (true
            ) {
             
             const sourceObj = {
               id: this.vaultids[i].sourceDnsId,
               name: this.vaultids[i].source,
               url: this.vaultids[i].url
             };
           
         //     const targetObj = {
         //       id: this.vaultids[i].targetDnsId,
         //       name: this.vaultids[i].target,
         //       url: this.vaultids[i].url
         //     };
         //     console.log(targetObj)
         //     console.log(sourceObj)
         //  this.dnsnames.push(targetObj);
             this.dnsnames.push(sourceObj);
             
           }
           else{
            this.dnsnames.push(this.vaultids[i])
           }
          }
       
          console.log(this.dnsnames)
        }
    }

     excelFileUploadForObjects(){
      const tablename = 'vaultobjectrelationship';
      const selectedNameOfdns = this.dnsid;
      console.log(selectedNameOfdns)
      let dialogRef = this.dialog.open(UploadExcelFileComponent, {
                  panelClass: 'custom-dialog-container-materialFulfilment',
                  width: '95%',
                  height:'80%',
                  maxWidth:'100vw',
                  autoFocus: false,
                  data: { edata:tablename,dnsname:selectedNameOfdns},
                  disableClose: true,
                });
                dialogRef.afterClosed().subscribe(result => {
                console.log(result)
                 if(result){
                  // this.excelData = result
                  this.selectDns(this.name)
                //  this.sendExcelData()
                 }
                  this.selectDns(this.name)
                //  input.value = '';
              })
          
  }
   importData() {
     
        console.log("<--- Inside upload Group Template --->")
        let width = "85%";
      let dialogRef = this.dialog.open(ImportJsonComponent, {
          maxWidth: "70vw",
          height: "50%",
          width: width,
        data: { "tablename": this.importExportTableName, "tenantid": this.dnsid },
          disableClose: true,
        });
      
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
      
          //this.reportCreationData = result;
      
          //this.vaultObjectService.retrieveobjectgroup();
        });
      
      
    }
    
  
    async exportData() {
      this.snackbar.open("Export Process is InProgress. Please do not click again the Export until it completes the Export.", "OK", { duration: 10000 });
      let tenantid = localStorage.getItem("dnsName")
     
  
        try {
          const blob = await this.commonService.downloadJsonFile(this.importExportTableName, this.dnsid+"");
          const link = document.createElement('a');
          const timestamp = new Date().getTime();
          link.href = window.URL.createObjectURL(blob);
          link.download = `${this.importExportTableName}_export_${timestamp}.json`;
          link.click();
          window.URL.revokeObjectURL(link.href);
  
        } catch (error) {
          console.error('Error downloading JSON:', error);
        }
      
      
    }
   
}
